import React from "react";
import { ShieldCheck, Lock } from "lucide-react";

export const Compliance = () => (
  <section
    id="compliance"
    data-testid="compliance-section"
    className="py-16 md:py-20 bg-white"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8">
      <div className="bg-navy rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-12 text-white grid grid-cols-12 gap-y-6 md:gap-8 items-center">
        <div className="col-span-12 md:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 text-[color:var(--brand-green-200)] px-4 py-1.5 text-xs font-bold tracking-[0.2em] uppercase">
            Compliance & Trust
          </span>
          <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold">
            HIPAA-aligned workflows. SOC 2–minded controls.
          </h2>
          <p className="mt-4 text-white/80 max-w-2xl leading-relaxed">
            Patient data privacy and operational security are non-negotiable. Every engagement is
            delivered with documented procedures, access controls, and audit trails so your
            practice stays compliant and your patients stay protected.
          </p>
        </div>
        <div className="col-span-12 md:col-span-5 flex flex-wrap gap-4 justify-start md:justify-end">
          <div
            data-testid="badge-hipaa"
            className="bg-white text-navy rounded-2xl px-6 py-5 flex items-center gap-3 min-w-[200px]"
          >
            <div className="w-12 h-12 rounded-xl bg-brand-green-100 flex items-center justify-center">
              <ShieldCheck className="w-7 h-7 text-[color:var(--brand-green-700)]" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[color:var(--brand-green-700)]">
                Compliance
              </div>
              <div className="font-display text-xl font-bold">HIPAA</div>
              <div className="text-[11px] text-slate-500">Aligned Workflows</div>
            </div>
          </div>
          <div
            data-testid="badge-soc2"
            className="bg-white text-navy rounded-2xl px-6 py-5 flex items-center gap-3 min-w-[200px]"
          >
            <div className="w-12 h-12 rounded-xl bg-brand-green-100 flex items-center justify-center">
              <Lock className="w-7 h-7 text-[color:var(--brand-green-700)]" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[color:var(--brand-green-700)]">
                Certification
              </div>
              <div className="font-display text-xl font-bold">SOC 2</div>
              <div className="text-[11px] text-slate-500">Security Posture</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
